import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
})
export class SearchBarComponent implements OnDestroy, OnInit {
  @Input() placeholder: string;
  @Input() showMoreOptions: boolean;
  @Input() showButtonIcon: boolean;
  @Input() moreOptions: any[];
  @Input() disableSearch: boolean;
  @Input() disabledSearchText: string;
  @Input() buttonIcon: string;
  @Output() searchKeywordChange: EventEmitter<any> = new EventEmitter();
  @Output() buttonIconClick: EventEmitter<any> = new EventEmitter<any>();
  searchFormSubscription: Subscription;
  searchForm: UntypedFormControl = new UntypedFormControl();

  ngOnInit() {
    this.searchFormSubscription = this.searchForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe((value: string) => this.searchKeywordChange.emit(value));
  }

  ngOnDestroy() {
    this.searchFormSubscription.unsubscribe();
  }
}
